/**
 * Name fields that become search words, in token order.
 *
 * The deceased's tokens are stored as `deceased.name.tokens` rows tagged
 * `name_token` - the index deceased-name search runs on
 * (conductor-server api/shared/search-arrangements-by-name.ts). A field left out
 * here cannot be searched for, which is how an AKA like "Baby of Isabella Sant"
 * went unfound.
 *
 * ORDER MATTERS. Tokens are stored as a list whose ids are positional
 * (`tokens.id-a`, `id-b`, ... from arraysToObjects), so a new field goes at the
 * END: every arrangement's existing tokens then keep their positions and only
 * gain new ones. The 2026-10-10 backfill
 * (conductor-server scripts/migrations/2026-10-10-1000-name-tokens-aka-birth-name.sql)
 * reproduces exactly this list for existing arrangements - change the fields
 * or the splitting rule and that backfill has to be redone to match.
 */
export const NAME_TOKEN_FIELDS = ['first', 'middle', 'last', 'lastNameAtBirth', 'aka'] as const;

/** One search word per whitespace-separated word of each name field, in order. */
export function tokenizeName(name: any): string[] {
  const fields = NAME_TOKEN_FIELDS.map((f) => name?.[f]).filter(Boolean);
  return fields.flatMap((field: string) => String(field).trim().split(/\s+/)).filter(Boolean);
}
